/* TheHoneyCo theme scripts. Vanilla, no dependencies. */
(function () {
  "use strict";

  var cfg = window.theme || {};
  var FOCUSABLE =
    'a[href],button:not([disabled]),textarea,input,select,[tabindex]:not([tabindex="-1"])';

  /* ---------------------------------------------------------------- utils */
  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $all(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  function formatMoney(cents) {
    try {
      return new Intl.NumberFormat("en-NZ", {
        style: "currency",
        currency: "NZD",
        currencyDisplay: "narrowSymbol",
      }).format(cents / 100);
    } catch (e) {
      return "$" + (cents / 100).toFixed(2);
    }
  }

  /* -------------------------------------------------------------- dialogs */
  var scrollLocks = 0;
  function lockScroll() { scrollLocks++; document.body.classList.add("drawer-open"); }
  function unlockScroll() { scrollLocks = Math.max(0, scrollLocks - 1); if (!scrollLocks) document.body.classList.remove("drawer-open"); }

  function Dialog(root, overlay) {
    this.root = root;
    this.overlay = overlay || null;
    this.trigger = null;
    this.onKey = this.onKey.bind(this);
  }
  Dialog.prototype.open = function (trigger) {
    this.trigger = trigger || document.activeElement;
    this.root.hidden = false;
    if (this.overlay) this.overlay.hidden = false;
    lockScroll();
    var f = this.root.querySelectorAll(FOCUSABLE);
    if (f.length) f[0].focus();
    document.addEventListener("keydown", this.onKey);
  };
  Dialog.prototype.close = function () {
    this.root.hidden = true;
    if (this.overlay) this.overlay.hidden = true;
    unlockScroll();
    document.removeEventListener("keydown", this.onKey);
    if (this.trigger && this.trigger.focus) this.trigger.focus();
  };
  Dialog.prototype.onKey = function (e) {
    if (e.key === "Escape") { e.preventDefault(); this.close(); return; }
    if (e.key !== "Tab") return;
    var items = $all(FOCUSABLE, this.root).filter(function (el) { return el.offsetParent !== null; });
    if (!items.length) return;
    var first = items[0], last = items[items.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  };

  /* --------------------------------------------------------------- header */
  function initHeader() {
    var header = $(".header");
    if (!header) return;
    var onScroll = function () { header.setAttribute("data-scrolled", window.scrollY > 8 ? "true" : "false"); };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });

    var menu = $("#MobileMenu");
    if (menu) {
      var dlg = new Dialog(menu);
      $all("[data-menu-open]").forEach(function (btn) {
        btn.addEventListener("click", function () { dlg.open(btn); btn.setAttribute("aria-expanded", "true"); });
      });
      menu.addEventListener("click", function (e) {
        if (e.target.closest("[data-menu-close]") || e.target.classList.contains("overlay")) {
          dlg.close();
          $all("[data-menu-open]").forEach(function (b) { b.setAttribute("aria-expanded", "false"); });
        }
      });
    }
  }

  /* ------------------------------------------------------------ accordion */
  function initAccordions() {
    $all(".accordion").forEach(function (acc) {
      var triggers = $all(".accordion__trigger", acc);
      triggers.forEach(function (trigger, i) {
        var panel = document.getElementById(trigger.getAttribute("aria-controls"));
        trigger.addEventListener("click", function () {
          var open = trigger.getAttribute("aria-expanded") === "true";
          if (!acc.hasAttribute("data-multiple")) {
            triggers.forEach(function (t) {
              t.setAttribute("aria-expanded", "false");
              var p = document.getElementById(t.getAttribute("aria-controls"));
              if (p) p.hidden = true;
            });
          }
          trigger.setAttribute("aria-expanded", open ? "false" : "true");
          if (panel) panel.hidden = open;
        });
        trigger.addEventListener("keydown", function (e) {
          var idx = -1;
          if (e.key === "ArrowDown") idx = (i + 1) % triggers.length;
          else if (e.key === "ArrowUp") idx = (i - 1 + triggers.length) % triggers.length;
          else if (e.key === "Home") idx = 0;
          else if (e.key === "End") idx = triggers.length - 1;
          if (idx >= 0) { e.preventDefault(); triggers[idx].focus(); }
        });
      });
    });
  }

  /* --------------------------------------------------------------- reveal */
  function initReveal() {
    if (!("IntersectionObserver" in window)) return;
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) { entry.target.setAttribute("data-in", "true"); io.unobserve(entry.target); }
        });
      },
      { rootMargin: "0px 0px -10% 0px", threshold: 0.1 }
    );
    $all(".reveal").forEach(function (el) { io.observe(el); });
  }

  /* ------------------------------------------------------- quantity input */
  function initQuantity(ctx) {
    $all(".qty", ctx || document).forEach(function (widget) {
      if (widget.dataset.bound) return;
      widget.dataset.bound = "1";
      var input = $("input", widget);
      var min = parseInt(input.getAttribute("min") || "1", 10);
      var max = parseInt(input.getAttribute("max") || "99", 10);
      var latest = parseInt(input.value, 10) || min;
      var debounceTimer;
      function set(v, immediate) {
        latest = Math.max(min, Math.min(max, v));
        input.value = latest;
        clearTimeout(debounceTimer);
        var fire = function () { input.dispatchEvent(new Event("change", { bubbles: true })); };
        if (immediate) fire(); else debounceTimer = setTimeout(fire, 350);
      }
      $all("button", widget).forEach(function (btn) {
        btn.addEventListener("click", function () {
          set(latest + (btn.dataset.dir === "up" ? 1 : -1));
        });
      });
      input.addEventListener("input", function () {
        var n = parseInt(input.value.replace(/\D/g, ""), 10);
        if (!isNaN(n)) latest = Math.max(min, Math.min(max, n));
      });
      input.addEventListener("blur", function () { set(latest, true); });
    });
  }

  /* ----------------------------------------------------------------- cart */
  var cartDrawer = null, cartDlg = null;
  var cartUpdateToken = 0; // guards against an out-of-order AJAX response overwriting a newer one

  function setCartBusy(isBusy) {
    // Locks the cart body while a quantity/remove request is in flight, so a
    // tap can't land on an element that's about to be torn down and rebuilt
    // by refreshCartSections (that race is what read as "freezes, can't tap").
    // A successful response replaces this markup entirely (no data-busy in
    // the fresh HTML), so the lock clears itself; the catch handlers clear it
    // explicitly if the request fails.
    $all(".cart-body, .cart-page form").forEach(function (el) {
      el.setAttribute("data-busy", isBusy ? "true" : "false");
    });
  }

  function refreshCartSections(html) {
    if (!html) return;
    var doc = new DOMParser().parseFromString(html, "text/html");
    var fresh = doc.querySelector("#shopify-section-cart-drawer");
    var current = document.querySelector("#shopify-section-cart-drawer");
    if (fresh && current) {
      // The server has no concept of "currently open" -- it always renders
      // #CartDrawer/#CartOverlay with the static `hidden` attribute from the
      // source template. Without restoring the real state after swapping in
      // that fresh markup, the drawer silently closes itself (and the dimmed
      // overlay can be left stuck showing with nothing open behind it) on
      // every single quantity change made while it's open -- this is the
      // actual cause of the reported freeze.
      var wasOpen = !!(cartDrawer && !cartDrawer.hidden);
      current.innerHTML = fresh.innerHTML;
      cartDrawer = $("#CartDrawer");
      bindCartDrawer();
      initQuantity(current);
      if (wasOpen && cartDrawer) {
        cartDrawer.hidden = false;
        if (cartDlg && cartDlg.overlay) cartDlg.overlay.hidden = false;
      }
    }
  }

  function updateCount(count) {
    $all("[data-cart-count]").forEach(function (el) {
      el.textContent = count;
      el.setAttribute("data-count", count);
    });
  }

  function openCart(trigger) {
    if (!cartDrawer) return;
    if (!cartDlg) cartDlg = new Dialog(cartDrawer, $("#CartOverlay"));
    cartDlg.open(trigger);
  }

  function cartRequest(url, body) {
    body.sections = "cart-drawer";
    body.sections_url = window.location.pathname;
    return fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify(body),
    }).then(function (r) { return r.json(); });
  }

  function bindCartDrawer() {
    cartDrawer = $("#CartDrawer");
    if (!cartDrawer) return;
    // refreshCartSections replaces this whole section's HTML, including
    // #CartOverlay -- keep the live Dialog pointed at the new node.
    if (cartDlg) cartDlg.overlay = document.querySelector("#CartOverlay");

    $all("[data-cart-close]", cartDrawer).forEach(function (btn) {
      btn.addEventListener("click", function () { if (cartDlg) cartDlg.close(); });
    });
    var overlay = document.querySelector("#CartOverlay");
    if (overlay && !overlay.dataset.bound) {
      overlay.dataset.bound = "1";
      overlay.addEventListener("click", function () { if (cartDlg) cartDlg.close(); });
    }

    $all("[data-line-key]", cartDrawer).forEach(function (row) {
      var key = row.getAttribute("data-line-key");
      var input = $(".qty input", row);
      if (input) {
        input.addEventListener("change", function () {
          var q = parseInt(input.value, 10) || 0;
          var token = ++cartUpdateToken;
          setCartBusy(true);
          cartRequest("/cart/change.js", { id: key, quantity: q }).then(function (cart) {
            if (token !== cartUpdateToken) return; // a newer cart update already landed -- drop this stale one
            updateCount(cart.item_count);
            refreshCartSections(cart.sections && cart.sections["cart-drawer"]);
            trackViewCart(cart);
          }).catch(function () { setCartBusy(false); });
        });
      }
      var remove = $("[data-line-remove]", row);
      if (remove) {
        remove.addEventListener("click", function () {
          var token = ++cartUpdateToken;
          setCartBusy(true);
          cartRequest("/cart/change.js", { id: key, quantity: 0 }).then(function (cart) {
            if (token !== cartUpdateToken) return;
            updateCount(cart.item_count);
            refreshCartSections(cart.sections && cart.sections["cart-drawer"]);
          }).catch(function () { setCartBusy(false); });
        });
      }
    });
  }

  function initCart() {
    bindCartDrawer();

    $all("[data-cart-open]").forEach(function (btn) {
      btn.addEventListener("click", function (e) { e.preventDefault(); openCart(btn); });
    });

    $all("form[action$='/cart/add']").forEach(function (form) {
      if (form.dataset.bound) return;
      form.dataset.bound = "1";
      form.addEventListener("submit", function (e) {
        e.preventDefault();
        var btn = form.querySelector('[type="submit"]');
        var fd = new FormData(form);
        var payload = { id: fd.get("id"), quantity: parseInt(fd.get("quantity") || "1", 10) };
        if (btn) { btn.disabled = true; btn.dataset.label = btn.textContent; btn.textContent = cfg.strings.added || "Added"; }
        cartRequest("/cart/add.js", { items: [payload] })
          .then(function (res) {
            if (res.status && res.status !== 200) { throw new Error(res.description || "Could not add to cart"); }
            refreshCartSections(res.sections && res.sections["cart-drawer"]);
            return fetch("/cart.js").then(function (r) { return r.json(); });
          })
          .then(function (cart) {
            updateCount(cart.item_count);
            trackAddToCart(form);
            openCart(btn);
          })
          .catch(function (err) { window.alert(err.message); })
          .finally(function () {
            if (btn) {
              setTimeout(function () {
                btn.disabled = false;
                btn.textContent = btn.dataset.label || cfg.strings.addToCart;
              }, 900);
            }
          });
      });
    });
  }

  /* ----------------------------------------------------------- cart page */
  function initCartPage() {
    var form = $("form[data-cart-autosubmit]");
    if (!form) return;
    var t;
    form.addEventListener("change", function (e) {
      if (!e.target.matches('input[name^="updates["]')) return;
      clearTimeout(t);
      form.setAttribute("data-busy", "true");
      t = setTimeout(function () { form.requestSubmit ? form.requestSubmit() : form.submit(); }, 400);
    });
  }

  /* ------------------------------------------------------ product gallery */
  function initGallery() {
    var gallery = $(".gallery");
    if (!gallery) return;
    var main = $(".gallery__main-media", gallery);
    var thumbs = $all(".gallery__thumb", gallery);
    thumbs.forEach(function (thumb) {
      thumb.addEventListener("click", function () {
        thumbs.forEach(function (t) { t.setAttribute("aria-current", "false"); });
        thumb.setAttribute("aria-current", "true");
        if (main) main.innerHTML = thumb.dataset.media;
      });
    });
  }

  /* ----------------------------------------------------- sticky buy bar */
  function initStickyBuy() {
    var bar = $(".sticky-buy");
    var anchor = $("[data-buy-anchor]");
    if (!bar || !anchor || !("IntersectionObserver" in window)) return;
    var pastAnchor = false;
    var footerVisible = false;
    var sync = function () {
      bar.setAttribute("data-visible", (pastAnchor && !footerVisible) ? "true" : "false");
    };
    var io = new IntersectionObserver(function (entries) {
      var e = entries[0];
      pastAnchor = !e.isIntersecting && e.boundingClientRect.top < 0;
      sync();
    }, { threshold: 0 });
    io.observe(anchor);
    var footer = $(".footer");
    if (footer) {
      var footerIo = new IntersectionObserver(function (entries) {
        footerVisible = entries[0].isIntersecting;
        sync();
      }, { threshold: 0 });
      footerIo.observe(footer);
    }
    var barForm = $("form", bar);
    var mainForm = $(".purchase form[action$='/cart/add']");
    if (barForm && mainForm) {
      barForm.addEventListener("submit", function (e) {
        e.preventDefault();
        mainForm.requestSubmit ? mainForm.requestSubmit() : mainForm.dispatchEvent(new Event("submit", { cancelable: true }));
      });
    }
  }

  /* --------------------------------------------------------- consent + analytics */
  var CONSENT_KEY = "thc_consent";
  function readConsent() {
    var m = document.cookie.split("; ").filter(function (r) { return r.indexOf(CONSENT_KEY + "=") === 0; })[0];
    var v = m && m.split("=")[1];
    return v === "granted" || v === "denied" ? v : "unset";
  }
  function writeConsent(state) {
    document.cookie = CONSENT_KEY + "=" + state + "; path=/; max-age=" + 60 * 60 * 24 * 180 + "; SameSite=Lax";
    if (state === "granted") loadAnalytics();
  }

  function initConsent() {
    var bar = $("#ConsentBar");
    if (!bar) return;
    if (readConsent() === "unset") bar.hidden = false;
    $("[data-consent-accept]", bar).addEventListener("click", function () { writeConsent("granted"); bar.hidden = true; });
    $("[data-consent-decline]", bar).addEventListener("click", function () { writeConsent("denied"); bar.hidden = true; });
    $all("[data-consent-open]").forEach(function (btn) {
      btn.addEventListener("click", function () { bar.hidden = false; });
    });
  }

  var analyticsLoaded = false;
  function loadAnalytics() {
    if (analyticsLoaded) return;
    var a = cfg.analytics || {};
    if (!a.ga4 && !a.meta && !a.tiktok) return;
    analyticsLoaded = true;

    if (a.ga4) {
      var s = document.createElement("script");
      s.async = true;
      s.src = "https://www.googletagmanager.com/gtag/js?id=" + a.ga4;
      document.head.appendChild(s);
      window.dataLayer = window.dataLayer || [];
      window.gtag = function () { window.dataLayer.push(arguments); };
      window.gtag("js", new Date());
      window.gtag("config", a.ga4, { send_page_view: true });
    }
    if (a.meta) {
      !(function (f, b, e, v, n, t, s) {
        if (f.fbq) return; n = f.fbq = function () { n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments); };
        if (!f._fbq) f._fbq = n; n.push = n; n.loaded = !0; n.version = "2.0"; n.queue = [];
        t = b.createElement(e); t.async = !0; t.src = v; s = b.getElementsByTagName(e)[0]; s.parentNode.insertBefore(t, s);
      })(window, document, "script", "https://connect.facebook.net/en_US/fbevents.js");
      window.fbq("init", a.meta);
      window.fbq("track", "PageView");
    }
    if (a.tiktok) {
      !(function (w, d, t) {
        w.TiktokAnalyticsObject = t; var ttq = (w[t] = w[t] || []);
        ttq.methods = ["page", "track", "identify", "instances", "debug", "on", "off", "once", "ready", "alias", "group", "enableCookie", "disableCookie"];
        ttq.setAndDefer = function (e, n) { e[n] = function () { e.push([n].concat(Array.prototype.slice.call(arguments, 0))); }; };
        for (var i = 0; i < ttq.methods.length; i++) ttq.setAndDefer(ttq, ttq.methods[i]);
        ttq.load = function (e) { var o = "https://analytics.tiktok.com/i18n/pixel/events.js"; ttq._i = ttq._i || {}; ttq._i[e] = []; ttq._i[e]._u = o; var s = d.createElement("script"); s.type = "text/javascript"; s.async = !0; s.src = o + "?sdkid=" + e + "&lib=" + t; var a = d.getElementsByTagName("script")[0]; a.parentNode.insertBefore(s, a); };
        ttq.load(a.tiktok); ttq.page();
      })(window, document, "ttq");
    }
  }

  var fired = {};
  function push(name, params) {
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: name, ecommerce: params });
    } catch (e) {}
    if (window.gtag) window.gtag("event", name, params);
    var metaMap = { view_item: "ViewContent", add_to_cart: "AddToCart", begin_checkout: "InitiateCheckout" };
    if (window.fbq && metaMap[name]) window.fbq("track", metaMap[name], { currency: "NZD", value: params.value });
    if (window.ttq && metaMap[name]) window.ttq.track(metaMap[name], { currency: "NZD", value: params.value });
  }
  function trackOnce(name, params) {
    var k = name + ":" + location.pathname;
    if (fired[k]) return;
    fired[k] = 1;
    push(name, params);
  }
  function trackAddToCart(form) {
    var d = form.dataset;
    push("add_to_cart", {
      currency: "NZD",
      value: parseFloat(d.price || "0"),
      items: [{ item_id: d.productHandle, item_name: d.productTitle, price: parseFloat(d.price || "0"), quantity: 1 }],
    });
  }
  function trackViewCart(cart) {
    push("view_cart", { currency: "NZD", value: cart.total_price / 100 });
  }
  function initPageEvents() {
    var el = $("[data-track-view-item]");
    if (el) {
      trackOnce("view_item", {
        currency: "NZD",
        value: parseFloat(el.dataset.price || "0"),
        items: [{ item_id: el.dataset.handle, item_name: el.dataset.title, price: parseFloat(el.dataset.price || "0") }],
      });
    }
    if ($("[data-track-view-list]")) {
      trackOnce("view_item_list", { items: [] });
    }
    var checkoutBtn = $("[name='checkout'], [data-begin-checkout]");
    if (checkoutBtn) {
      checkoutBtn.addEventListener("click", function () {
        push("begin_checkout", { currency: "NZD", value: 0 });
      });
    }
  }

  /* --------------------------------------------------------------- boot */
  function boot() {
    initHeader();
    initAccordions();
    initReveal();
    initQuantity();
    initCart();
    initCartPage();
    initGallery();
    initStickyBuy();
    initConsent();
    initPageEvents();
    if (readConsent() === "granted") loadAnalytics();
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();

  document.addEventListener("shopify:section:load", boot);
})();
